import { Settings } from 'lucide-react';
import { SettingsSidebar } from './components/settings-sidebar';
import { useSetPageTitle } from '@/hooks/use-page-title';

export default function SettingsLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  useSetPageTitle('Settings', Settings);
  return (
    <div className="flex flex-col h-full w-full">
      <div className="flex flex-1 overflow-hidden">
        <SettingsSidebar />
        <div className="flex-1 overflow-auto bg-muted/40">
          {children}
        </div>
      </div>
    </div>
  );
}
